import { OfficesList } from "@mnk/frontend/components/domain/offices/List";

export const Home = () => {
  return <OfficesList />;
};
